(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-ufi-mobile-navigation]').forEach(dialog => {
      if (dialog.dataset.ufiReady) return;
      dialog.dataset.ufiReady = 'true';
      const trigger = document.querySelector('[data-ufi-mobile-open][aria-controls="' + dialog.id + '"]');
      if (!trigger || typeof dialog.showModal !== 'function') return;
      let previousOverflow = '';
      function close() { if (dialog.open) dialog.close(); }
      trigger.addEventListener('click',() => {
        if (dialog.open) { close(); return; }
        previousOverflow = document.documentElement.style.overflow;
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        trigger.setAttribute('aria-expanded','true');
        dialog.querySelector('[data-ufi-mobile-close]').focus({preventScroll:true});
      });
      dialog.querySelector('[data-ufi-mobile-close]').addEventListener('click',close);
      dialog.addEventListener('click',event => {
        if (event.target === dialog) {
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
        }
        if (event.target.closest('a[href]')) close();
      });
      dialog.addEventListener('close',() => {
        document.documentElement.style.overflow = previousOverflow;
        trigger.setAttribute('aria-expanded','false');
        trigger.focus({preventScroll:true});
      });
      dialog.querySelectorAll('.ufi-mnav-category').forEach(category => category.addEventListener('toggle',() => {
        if (!category.open) return;
        dialog.querySelectorAll('.ufi-mnav-category').forEach(other => { if (other !== category) other.open = false; });
      }));
      const desktop = window.matchMedia('(min-width:1100px)');
      desktop.addEventListener('change',event => { if (event.matches) close(); });
      document.addEventListener('shopify:section:unload',event => { if (event.target.contains(dialog)) close(); });
    });
  }
  init();
  document.addEventListener('shopify:section:load',event => init(event.target));
})();
